import { Injectable } from '@angular/core';
import { API } from './api.service';
import {empty} from "rxjs/Observer";

@Injectable()
export class RadioService {
    constructor(private api: API) {

    }

    getMyRadios(term,sortOrder: any = false,limit,page) {


        // return this.api.get('playlists/my-radio?q=' + encodeURI(term));
        let queryParams = '?time='+Date.now();
         if(term!=""){
             queryParams +="&q="+term;
         }
        if (limit) {
            queryParams += '&limit=' + limit;
        }

        if (page) {
            queryParams += '&page=' + page;
        }
        if (sortOrder && sortOrder.key) {
            queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        let url = "playlists/my-radio" + queryParams;
        return this.api.get(url);


    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/radio.service.ts